import { playerDisplayName } from "./PlayerDisplayNameLink";
export const sortPlayers = (a, b) => {
    if (!a) {
        return -1;
    }
    if (!b) {
        return 1;
    }
    return playerDisplayName(a) < playerDisplayName(b) ? -1 : 1;
};
